import { ExperimentData } from '@absmartly/javascript-sdk/types/context';

type GetVariationKeyProps = {
  experiment?: ExperimentData;
  variantIndex: number;
};
export const getVariationName = ({
  experiment,
  variantIndex,
}: GetVariationKeyProps) => {
  if (!experiment) return 'control';
  const variant = experiment.variants[variantIndex];
  if ('name' in variant && typeof variant.name === 'string') {
    return variant.name;
  }
  return 'control';
};
